__turbopack_context__.v({
  "clickContainer": "ShippingHistoryToggle-module__Y2pCvG__clickContainer",
});
